import ko from 'rgs-knockout';
import page from 'page-common';
import {EventEmitter} from "event-emitter";

import {unwrap} from './func-unwrapper';

export class Dialog extends EventEmitter {
	_dialog = {};

	_create = data => page.modals.create(data);

	_show (dialog) {
		page.modals.show(dialog || this._dialog);
	}

	_hide (dialog) {
		page.modals.hide(dialog || this._dialog);
	}
}

export class DynamicDialog extends Dialog {
	_temp = ko.observable({});
	_isOpened = ko.observable(false);

	constructor (params, ...args) {
		super(params, ...args);

		this._modal = this._create({
			templateMode: unwrap(params.templateMode) || 'nfd-content',
			template: {
				html: unwrap(params.html, params.templateOptions || {}),
				data: this,
			},
			css: params.css,
		});

		this.props = {
			temp: this._temp,
		};
	}

	get isDialogOpened () {
		return this._isOpened();
	}

	showSelf () {
		this._show(this._modal);
		this._isOpened(true);

		return this;
	}

	hideSelf () {
		this._hide(this._modal);
		this._isOpened(false);
	}

	showWithTempData (item) {
		this._temp(item);

		this.showSelf(this._modal);
	}
}
